import React from 'react'
import { Box } from 'components/Layout'
// import { Button } from 'components/Button'
// import history from '../../history'

import ToDoList from '../../containers/ToDoList'

const AppIsIncomplete = ({ incomplete, appId }) => {
	// const appSubPath = path => '/apps/' + appId + '/' + path
	return incomplete ? (
		<Box
			header={'App configuration is incomplete'}
			body={
				<span>
					<p>
						Before you install the app, please finish the app
						configuration:
					</p>
					<ToDoList appId={appId} withoutInstall />
				</span>
			}
			bodyPadding
		/>
	) : null
}

export default AppIsIncomplete



// WEBPACK FOOTER //
// ./src/views/Banners/AppIsIncompleteBanner.js